export default {
  "contact.title": "Contáctanos",
  "contact.subtitle": "Estamos aquí para ayudarte a planear tu viaje perfecto a Baja California Sur",
  "contact.infoTitle": "Información de contacto",
  "contact.emailLabel": "Correo electrónico",
  "contact.phoneLabel": "Teléfono",
  "contact.addressLabel": "Dirección",
  "contact.addressValue": "La Paz, B.C.S., México",
  "contact.whatsappLabel": "WhatsApp",
  "contact.hoursTitle": "Horario de atención",
  "contact.weekdays": "Lunes - Viernes",
  "contact.saturday": "Sábado",
  "contact.sunday": "Domingo",
  "contact.closed": "Cerrado",
  "contact.emergencyTitle": "¿Necesitas ayuda urgente?",
  "contact.emergencyDesc": "Si tienes un problema con una reserva que está sucediendo ahora, contáctanos directamente por WhatsApp.",
  "contact.emergencyButton": "Chatear por WhatsApp",
  "contact.nameLabel": "Nombre",
  "contact.namePlaceholder": "Tu nombre completo",
  "contact.subjectLabel": "Asunto",
  "contact.subjectPlaceholder": "¿En qué podemos ayudarte?",
  "contact.messageLabel": "Mensaje",
  "contact.messagePlaceholder": "Cuéntanos más sobre tu pregunta o problema...",
  "contact.maxChars": "Máximo 500 caracteres",
  "contact.sendButton": "Enviar mensaje",
  "contact.privacyNote": "Al enviar este mensaje aceptas nuestra",
  "contact.privacyLink": "política de privacidad",
  "contact.sentTitle": "Mensaje enviado",
  "contact.sentDesc": "Recibimos tu mensaje y responderemos dentro de 24 horas.",
  "contact.sendAnother": "Enviar otro mensaje",
};